export const mfManifestsPath = '/assets/module-federation.manifest.vup.json'
